module.exports = __webpack_public_path__ + "static/media/4.5fd5b90e.JPG";